<template>
  <v-toolbar
    id="core-toolbar"
    flat
    prominent
    style="background: #eee;"
  >
    <div class="v-toolbar-title">
      <v-toolbar-title
        class="tertiary--text font-weight-light"
      >
        <v-toolbar-side-icon @click.stop="toggleSidebar" class="hidden-md-and-up"></v-toolbar-side-icon>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="logout">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Toolbar',
  data: () => ({
    dialog: false,
    drawer: null,
    title: null,
    responsiveInput: false,
  }),

  watch: {
    $route(val) {
      this.title = val.name;
    },
  },

  mounted() {
    this.title = this.$router.currentRoute.name;
  },
  computed: {
    ...mapGetters({
      username: 'guest/auth/username',
    }),
  },
  methods: {
    ...mapActions({
      signOut: 'guest/auth/signOut',
      toggleSidebar: 'common/ui/toggleSidebar',
    }),
    onClickBtn() {
      // this.setDrawer(!this.$store.state.app.drawer);
    },
    onClick() {
      //
    },
    logout() {
      this.signOut().then((success) => {
        if (success) {
          this.$router.push({ name: 'SignIn' });
        }
      });
    },
  },
};
</script>

<style scoped>
  #core-toolbar a {
    text-decoration: none;
  }
</style>
